import { inject, Injectable } from '@angular/core';
import { UserJourneyContext } from '@campus/ab-test';
import { DalState, PersonInterface, SchoolInterface, SchoolQueries, UserQueries } from '@campus/dal';
import { Store } from '@ngrx/store';
import { combineLatest, distinctUntilChanged, filter, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WrapperViewModel {
  public currentUser$: Observable<PersonInterface>;
  public userJourneyContext$: Observable<UserJourneyContext>;

  private currentSchools$: Observable<SchoolInterface[]>;

  private store: Store<DalState> = inject(Store);

  constructor() {
    this.initialize();
  }

  private initialize() {
    this.initializeStreams();
  }

  private initializeStreams(): void {
    this.currentUser$ = this.getCurrentUser$();
    this.currentSchools$ = this.getCurrentSchools$();

    this.userJourneyContext$ = this.getUserJourneyContext$();
  }

  private getCurrentUser$(): Observable<PersonInterface> {
    return this.store.select(UserQueries.getCurrentUser);
  }

  private getCurrentSchools$(): Observable<SchoolInterface[]> {
    return this.store.select(SchoolQueries.getAll);
  }

  private getUserJourneyContext$(): Observable<UserJourneyContext> {
    return combineLatest([this.currentUser$, this.currentSchools$]).pipe(
      filter(([user, schools]) => !!user && !!schools?.length),
      distinctUntilChanged(([prevUser], [currUser]) => prevUser.id === currUser.id),
      map(([user, schools]) => {
        const role = user.types?.[0];

        // Do not set a schoolId if the array has more than one entry
        const schoolId: number = schools.length === 1 ? schools[0].id : undefined;

        const journeyContext: UserJourneyContext = { role, schoolId };

        return journeyContext;
      })
    );
  }
}
